export function capitalizeName(name: string): string {
  return name
    ? name
        .split(" ") // Split the name by spaces
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ) // Capitalize first letter and make the rest lowercase
        .join(" ")
    : ""; // Join the words back together
}
